import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=5719d513&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=5719d513&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719d513",
  null
  
)

export default component.exports